import { api } from "../api/apiClient";

const handleError = (error, action) => {
  console.error(`Error ${action}:`, error);
  throw error;
};

export const registerUser = async (userData) => {
  try {
    const response = await api.post("/api/auth/register-user", userData);
    return response.data;
  } catch (error) {
    return handleError(error, "Failed to create new user.");
  }
};

export const authenticateUser = async (clerkUserId) => {
  try {
    const response = await api.post("/api/auth/authenticate-user", null, {
      params: { clerkUserId },
    });
    return response.data;
  } catch (error) {
    handleError(error, "authenticating user");
  }
};

export const getUserByClerkId = async (clerkUserId) => {
  try {
    const response = await api.get("/api/auth/get-user-by-clerk-id", {
      params: { clerkUserId },
    });
    return response.data;
  } catch (error) {
    handleError(error, "fetching user");
  }
};

// New function to store user online status
export const storeUserOnlineStatus = async (userId, isOnline) => {
  try {
    const response = await api.post("/api/auth/store-user-online-status", {
      userId,
      isOnline,
    });
    return response.data;
  } catch (error) {
    handleError(error, "storing user online status");
  }
};
